import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useFaveButton } from '../../../../FaveButton/useFaveButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
const FaveControl = ({ deviation, showStatNumbers = true, iconSizeOverride, className })=>{
    const { t } = useTranslation();
    const buttonRef = useRef(null);
    const { showStats } = useOverlayContext(deviation);
    const { isFavourite, faveCount, onClick: onFaveClick, biData } = useFaveButton(deviation);
    const handleClick = useCallback(()=>{
        onFaveClick();
        if (buttonRef.current) {
            buttonRef.current.blur();
        }
    }, [
        onFaveClick
    ]);
    const showStatValue = showStats && showStatNumbers && faveCount !== 0;
    return /*#__PURE__*/ React.createElement(ThumbIconButton, {
        ref: buttonRef,
        className: className,
        iconSizeOverride: iconSizeOverride,
        type: "fave",
        "aria-label": t('deviationview.overlay.a11y.favourite', {
            count: showStatValue ? faveCount : 0
        }),
        isEngaged: isFavourite,
        showStatValue: showStatValue,
        statValue: faveCount,
        onClick: handleClick,
        biData: biData
    });
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;

//# sourceMappingURL=FaveControl.js.map